import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { CourseService } from '../shared/services/course.service';
import { TagService } from '../shared/services/tag.service';
import { Course } from '../shared/models/course.model';
import { Tag } from '../shared/models/tag.model';
import { TagCategory } from '../shared/models/tag-category.model';

import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';

@Component({
    selector: 'app-courses',
    templateUrl: './courses.component.html',
    styleUrls: ['./courses.component.scss']
})

export class CoursesComponent implements OnInit {

    constructor(
        private courseService: CourseService,
        private tagService: TagService,
        private router: Router,
        private activatedRoute: ActivatedRoute
        ) {
    }

    selectedCourses: Course[];
    selectedTagsFromCategories: TagCategory[] = new Array<TagCategory>();
    showAllCourses: boolean = true; // boolean used to check for which view to show - "tagged courses" of "all course"
    courseLevels: Array<any> = [200,300,400];
    hasTaggedCourses: boolean = false;
    expandedCourse:Course;
    preReqCourses: Array<Course> = new Array<Course>();
    recommendedCourses: Array<Course> = new Array<Course>();
    type:string;
    pageLoad = true;
    tagUpdatedSubscription;
    routerEventsSubscription;

    ngOnInit(): void {
        this.activatedRoute.params.subscribe(params => {
            this.type = params['type']; 
        });   

        this.routerEventsSubscription = this.router.events
            .filter(event => event instanceof NavigationEnd)
            .map(() => this.activatedRoute)
            .map(route => {
                while (route.firstChild) route = route.firstChild;
                return route;
            })
            .filter(route => route.outlet === 'primary')
            .mergeMap(route => route.data)
            .subscribe((event) => {
                if(!this.pageLoad){
                    this.updateCourseView();
                }
            });

        this.courseService.getCoursesAndTags().then(res => {
            this.selectedTagsFromCategories = this.tagService.populatedTagCategories;
            this.updateCourseView();    
            this.pageLoad = false; 
        });

        this.tagUpdatedSubscription = this.tagService.tagUpdated.subscribe((item) => { this.updateCourseView(item, true)});
    }

    ngOnDestroy() {
        // clean up subscriptions
        this.tagUpdatedSubscription.unsubscribe();
        this.routerEventsSubscription.unsubscribe();
    }

    updateCourseView(event = null, triggerRedirect = false): void{
        // set correct view based on route
        if(this.type == "tagged"){
            this.showAllCourses = false;
        } else {
            this.showAllCourses = true;
        }

        // reset selected courses and course levels
        this.selectedCourses = this.courseService.getSelectedCourses();  
        this.courseLevels = this.getSelectedCourseLevels(this.selectedCourses, this.showAllCourses);

        // set which tab is enabled, based on course relevancy
        if(this.selectedCourses.find(el => el.relevancy > 0)) {
            this.hasTaggedCourses = true;
        } else{
            this.hasTaggedCourses = false;

            // only redirect if specifically set or if URL is tagged, but there are no tagged courses
            if(triggerRedirect || this.type == "tagged"){
                this.router.navigate(['/courses/all']);   
            }
        }
    }
    
    getSelectedCourseLevels(selectedCourses: Course[], showAll: boolean = true): Array<any>{
        let selectedCourseLevels = new Array<any>();

        selectedCourses.forEach((courseObj, i, array) => {
            if(courseObj.courseNumber > 199 && (showAll || courseObj.relevancy > 0)){
                selectedCourseLevels.push(Math.floor(courseObj.courseNumber / 100) * 100); 
            }
        });

        selectedCourseLevels = selectedCourseLevels.filter((value, index, array) => array.indexOf(value) === index).sort();

        return selectedCourseLevels;
    }

    checkIfPreReq(course:Course){
        let isPreReq = false;
        this.preReqCourses.forEach((courseObj, i, array) => {
            if(courseObj.id == course.id){
                isPreReq = true;
            }
        });
        return isPreReq;
    }

    checkIfUnlocked(course:Course){
        let isUnlocked = false;
        if(this.expandedCourse != null){            
            if(course.prerequisites.find(prereq => prereq.id == this.expandedCourse.id)) {
                isUnlocked = true;
            }
        }
        return isUnlocked;
    }

    checkIfRecommended(course:Course){
        let isRecommended = false;
        this.recommendedCourses.forEach((courseObj, i, array) => {
            if(courseObj.id == course.id){
                isRecommended = true;
            }
        });
        return isRecommended;
    }

    courseCardExpanded(course:Course): void{
        this.preReqCourses = course.prerequisites;
        this.expandedCourse = course;
        this.recommendedCourses = course.recommended;
    }

    toggleCourses(showAllCourses: boolean): void {
        if(showAllCourses){
            this.router.navigate(['/courses/all']);   
        }
        else{
            this.router.navigate(['/courses/tagged']);   
        }
    }
}


// WEBPACK FOOTER //
// C:/dev/um.stamps/src/app/courses/courses.component.ts